<kendo-dialog *ngIf="correctionFormActive" (close)="closeCorrectionForm()" [width]="600">
    <kendo-dialog-titlebar>
        <h3>{{'REPORT-INCORRECT-INFORMATION' | translate}}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="correctionForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark"> {{'SERVICE-NAME' | translate}}: </span>{{serviceName}}
                </label>
            </div>
        </div>
        <div class="row" *ngIf="serviceAddress">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark"> {{'SERVICE-ADDRESS' | translate}}: </span> {{serviceAddress}}
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label for="correctionType" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'CORRECTION-TYPE' | translate }} *
                    </span>
                    <kendo-combobox class="w-100" formControlName="correctionType"
                        [data]="communityServiceCorrectionTypes" [textField]="'displayName'" [valueField]="'id'"
                        [valuePrimitive]="false">
                    </kendo-combobox>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="correctionType.hasError('required') && correctionType.touched">
                        {{'REQUIRED-COMMUNITY-SERVICE-CORRECTION-TYPE' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'CORRECTION-DESCRIPTION' | translate }} *
                    </span>
                    <textarea kendoTextArea rows="5" formControlName="correctionDescription" class="w-100"></textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="correctionDescription.hasError('required') && correctionDescription.touched">
                        {{'REQUIRED-COMMUNITY-SERVICE-CORRECTION-DESCRIPTION' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!correctionForm.valid || !correctionForm.dirty"
            (click)="onSend($event)">{{ 'SEND' | translate }}<i class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>